@if(seasonTemporaryClosed) {
<div class="alert danger">
    <!--Your country is not open for applications just yet, but should be ready to take application soon.-->
    You are required to pass an interview to complete your application.
    We are not currently interviewing in your country. We will be in touch as soon as interviews open.
</div>
}